import { GET_PROMO_SLIDER, GET_PROMO_BANNER } from "./actionTypes";
import { GET_PROMO_SLIDER_URL, GET_PROMO_BANNER_URL } from "../../configs";
import Axios from "axios";

export const getPromoSlides = location_name => dispatch => {
    Axios.get(GET_PROMO_SLIDER_URL, {
        location_name: location_name
    })
        .then(response => {
            const promo_slides = response.data;
            return dispatch({ type: GET_PROMO_SLIDER, payload: promo_slides });
        })
        .catch(function(error) {
            console.log(error);
        });
};

export const getPromoBanners = () => dispatch => {
    Axios.get(GET_PROMO_BANNER_URL)
        .then(response => {
            const promo_banners = response.data;
            return dispatch({ type: GET_PROMO_BANNER, payload: promo_banners });
        })
        .catch(function(error) {
            console.log(error);
        });
};
